"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigation = void 0;
const tslib_1 = require("tslib");
const deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
// tslint:disable:object-literal-sort-keys
exports.navigation = {
    'bluebase.navigator.root': [
        {
            key: 'bluebase-navigator-root-internal-default',
            priority: 3,
            value: async (inputNavigator, opts, BB) => {
                const navigator = {
                    type: 'switch',
                    initialRouteName: 'Root',
                    routes: [
                        {
                            name: 'Root',
                            path: '',
                            screen: 'SystemLayout',
                            navigator: await BB.Filters.run('bluebase.navigator.main', {}, opts),
                            options: {
                                header: null,
                            },
                        },
                    ],
                };
                return deepmerge_1.default(inputNavigator, navigator);
            },
        },
    ],
    'bluebase.navigator.main': [
        {
            key: 'bluebase-navigator-main-internal-default',
            priority: 3,
            // tslint:disable-line:object-literal-sort-keys
            value: async (inputNavigator, opts, BB) => {
                let mainRoutes = [
                    {
                        name: 'Home',
                        path: '',
                        exact: true,
                        screen: 'HomeScreen',
                        options: {
                            headerLeft: null,
                            title: BB.Configs.getValue('title'),
                        },
                    },
                ];
                const routeMap = await BB.Plugins.getRouteMap(opts);
                Object.values(routeMap).forEach((routesArr) => (mainRoutes = mainRoutes.concat(routesArr)));
                const navigator = {
                    type: 'stack',
                    initialRouteName: 'Home',
                    routes: mainRoutes,
                };
                return deepmerge_1.default(inputNavigator, navigator);
            },
        },
    ],
};
